import ModuleLayout from "../../components/enterprise/ModuleLayout";
import MapPanel from "../../components/enterprise/MapPanel";
import { monitoringTabs } from "../navigation";
import { useTranslation } from "react-i18next";
import EmptyState from "../../components/dashboard/EmptyState";
import { usePlatform } from "../../context/PlatformContext";

const StoreMapPage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  return (
    <ModuleLayout title={t("platform.pages.storeMap.title")} subtitle={t("platform.pages.storeMap.subtitle")} breadcrumbs={[t("platform.nav.monitoring"), t("platform.tabs.map")]} tabs={monitoringTabs} dataMode={{ mode: showMockData ? "mock" : "real", source: showMockData ? t("platform.sources.digitalTwin") : "Absolluty API" }}>
      {showMockData ? (
        <MapPanel dataMode={{ mode: "mock", source: t("platform.sources.digitalTwin") }} />
      ) : (
        <EmptyState title={t("platform.mock.disabledTitle")} description={t("platform.mock.disabledMapDescription")} />
      )}
    </ModuleLayout>
  );
};

export default StoreMapPage;
